//https://github.com/JakeChampion/polyfill-library/blob/master/polyfills/Element/prototype/replaceChildren/polyfill.js

if (!("Element" in self && "replaceChildren" in Element.prototype)) {
  console.info("polyfill replaceChildren execute");
  Document.prototype.replaceChildren = Element.prototype.replaceChildren =
    function replaceChildren() {
      while (this.firstChild) {
        this.removeChild(this.firstChild);
      }
      this.append.apply(this, arguments);
    };
}

if (!("at" in Array.prototype)) {
  console.info("polyfill Array.at execute");
  Array.prototype.at = function (index) {
    index = index >= 0 ? index : this.length + index;

    if (index >= 0 && index < this.length) {
      return this[index];
    } else {
      return undefined;
    }
  };
}
